module.exports = __webpack_public_path__ + "img/img_left_nav_money_hover.8347551b.svg";